import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-laasy-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './laasy-modal.component.html',
  styleUrls: ['./laasy-modal.component.scss']
})
export class LaasyModalComponent {
  private _isModalOpen: boolean = true;

  get modalVisible(): boolean {
    return this._isModalOpen;
  }

  set modalVisible(value: boolean | Event) {
    this._isModalOpen = typeof value === 'boolean' ? value : false;
  }

  @Input() modalTitle: string = 'Confirmation';
  @Input() modalMessage: string = 'Are you sure you want to proceed?';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() confirmButtonText: string = 'Confirm';
  @Input() modalWidth:  number = 400;
  @Output() cancelButtonClicked =  new EventEmitter<void>();
  @Output() confirmButtonClicked = new EventEmitter<void>();
  @Output() modalOpened = new EventEmitter<void>();

  closeModal(): void {
    this._isModalOpen = false;
    this.cancelButtonClicked.emit();
  }

  confirmAction(): void {
    this._isModalOpen = false;
    this.confirmButtonClicked.emit();
  }

  openModal(): void {
    this._isModalOpen = true;
    this.modalOpened.emit();
  }
}
